import { Component, computed, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CellOverlayAction } from '@shared/components/table/table-cell/actions-overlay/actions-overlay.component';
import { formatCellValue } from '@shared/components/table/table-cell/utils';

@Component({
  selector: 'app-datetime-cell',
  imports: [],
  templateUrl: './datetime-cell.component.html'
})
export class DatetimeCellComponent {
  private readonly translate = inject(TranslateService);

  availableCellActions: CellOverlayAction[] = ['copy'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) =>
    formatCellValue(v, this.display(), this.translate.getCurrentLang());

  value = input<unknown | undefined>(undefined);
  display = input<'datetime' | 'date' | 'time'>('datetime');

  protected processedValue = computed<string>(() =>
    formatCellValue(this.value(), this.display(), this.translate.getCurrentLang())
  );
}
